module.exports = __webpack_public_path__ + "static/img/product-swipe9.75371021.png";